import React from "react";
import styles from "./scss/Input.module.scss";

const Textarea = ({ id, label, type, name, placeholder }) => {
  return (
    <div className={styles.inputContainer}>
      <label htmlFor={id}>{label}</label>
      <textarea type={type} id={id} name={name} placeholder={placeholder} rows={5}  />
    </div>
  );
};

export default Textarea;
